// extracted by mini-css-extract-plugin
module.exports = {"Tab":"MyOrders_Tab__2fXc6"};